import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  ModalClose,
  ModalDialog,
  Typography,
} from "@mui/joy";

import { useModal } from "./useModal";

export default function GenericModal({
  title,
  body,
}: {
  title?: string | JSX.Element;
  body: string | JSX.Element;
  buttons?: unknown;
}) {
  const { close } = useModal();

  return (
    <ModalDialog>
      <ModalClose />
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>
        <Typography sx={{ maxWidth: 350 }}>{body}</Typography>
      </DialogContent>
      <DialogActions>
        <Button color="neutral" variant="soft" onClick={close} sx={{ flex: 1 }}>
          Close
        </Button>
      </DialogActions>
    </ModalDialog>
  );
}
